module.exports = __webpack_public_path__ + "media/fall_2024_sweepstakes/tiktok-4bb9a022.svg";